module.exports = __webpack_public_path__ + "static/media/male.9fec2fd1.png";